export default function (adminURL, instance) {
  return {
    getGroupsData: () => instance.get(adminURL + "user/groups"),
    getUsersData: (payload) => instance.post(adminURL + "user/all", payload),
    createUser: (payload) => instance.post(adminURL + "user/create", payload),
    updateUser: (id, payload) => instance.put(adminURL + `user/${id}`, payload),
    removeUser: (id) => instance.delete(adminURL + `user/${id}`),
  };
}
